import { queryOptions, useQuery } from '@tanstack/react-query'
import { apiV1 } from '@/shared/api/apiPrefix'
import { httpClient } from '@/shared/lib/httpClient'
import {
  analyticsConfigResponseSchema,
  type AnalyticsProviderConfigItem,
} from '@/shared/schemas/analyticsConfig.schema'

export const analyticsConfigKeys = {
  all: ['analytics-config'] as const,
}

export const analyticsConfigQueryOptions = queryOptions({
  queryKey: analyticsConfigKeys.all,
  queryFn: async (): Promise<AnalyticsProviderConfigItem[]> => {
    const res = await httpClient.get<unknown>(apiV1('/analytics-config'))
    return analyticsConfigResponseSchema.parse(res.data).data
  },
  staleTime: 5 * 60 * 1000,
})

export function useAnalyticsConfig() {
  return useQuery(analyticsConfigQueryOptions)
}

export type { AnalyticsProviderConfigItem }
